import React from "react";
import { FiUser, FiPhone, FiMail } from "react-icons/fi";
import { PassengerCard as Card, Label, I, S, InputShell, Help, FieldError } from "./fields";

const genders = ["MALE", "FEMALE", "OTHER"];

export default function PassengerSection({
  v,
  set,
  errors,
  readOnly,
}) {
  return (
    <Card
      title="Passenger Details"
      subtitle="Basic contact info for the rider"
      icon={<FiUser className="w-5 h-5" />}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div data-field="paxPhone">
          <Label required>Mobile No</Label>
          <InputShell icon={<FiPhone className="w-4 h-4" />}><I type="tel" inputMode="tel" value={v.paxPhone} onChange={set("paxPhone")} placeholder="10 digit number" readOnly={readOnly} invalid={!!errors.paxPhone} /></InputShell>
          <FieldError msg={errors.paxPhone} />
        </div>
        <div data-field="paxName">
          <Label required>Name</Label>
          <InputShell icon={<FiUser className="w-4 h-4" />}><I value={v.paxName} onChange={set("paxName")} placeholder="Full name" readOnly={readOnly} invalid={!!errors.paxName} /></InputShell>
          <FieldError msg={errors.paxName} />
        </div>
        <div data-field="email">
          <Label>Email ID</Label>
          <InputShell icon={<FiMail className="w-4 h-4" />}><I type="email" value={v.email} onChange={set("email")} placeholder="name@company.com" readOnly={readOnly} invalid={!!errors.email} /></InputShell>
          <FieldError msg={errors.email} />
        </div>
        <div>
          <Label>Gender (Optional)</Label>
          <S value={v.gender} onChange={set("gender")} readOnly={readOnly}>
            <option value="">-- Select --</option>
            {genders.map((g)=> <option key={g} value={g}>{g}</option>)}
          </S>
        </div>
        <div data-field="mobile2">
          <Label>Mobile 2 (optional)</Label>
          <I type="tel" inputMode="tel" value={v.mobile2 || ""} onChange={set("mobile2")} placeholder="Alternate phone" readOnly={readOnly} invalid={!!errors.mobile2} />
          {errors.mobile2 ? <FieldError msg={errors.mobile2} /> : <Help>For coordination if primary is unreachable</Help>}
        </div>
        <div data-field="emailAlt">
          <Label>Email (Alternate)</Label>
          <I type="email" value={v?.emailAlt} onChange={set("emailAlt")} placeholder="Alternate email" readOnly={readOnly} invalid={!!errors.emailAlt} />
          <FieldError msg={errors.emailAlt} />
        </div>
      </div>
    </Card>
  );
}
